import Vue from 'vue'
import Router from 'vue-router'
import AuthLogin from '@/views/auth/Login'
import AuthLogout from '@/views/auth/Logout'
import StaffMemberListing from "@/views/staffMembers/StaffMemberListing";
import StaffMemberForm from "@/views/staffMembers/StaffMemberForm";
import NotFound from "@/views/NotFound";
import {i18n} from "@/libs/i18n";
import ProductForm from "@/views/products/ProductForm";
import ProductListing from "@/views/products/ProductListing";
import RoleForm from "@/views/roles/RoleForm";
import RoleListing from "@/views/roles/RoleListing";
import ForgotPassword from "@/views/auth/ForgotPassword";
import ProductCategoryForm from "@/views/productCategories/ProductCategoryForm";
import StoreForm from "@/views/stores/StoreForm";
import StoreListing from "@/views/stores/StoreListing";
import GeneralSettingsForm from "@/views/GeneralSettingsForm";
import MenuForm from "@/views/menus/MenuForm";
import MenuListing from "@/views/menus/MenuListing";
import OrderListing from "@/views/orders/OrderListing";
import moment from "moment";
import PrinterSettingsForm from "@/views/PrinterSettingsForm";
import ProductSalesReport from "@/views/reports/ProductSalesReport";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            // name: 'dashboard',
            // component: Dashboard
            redirect: '/orders'
        },
        {
            path: '/orders',
            name: 'orderListing',
            component: OrderListing
        },
        {
            path: '/menus/:id',
            name: 'menuForm',
            component: MenuForm
        },
        {
            path: '/menus',
            name: 'menuListing',
            component: MenuListing
        },
        {
            path: '/menus/:menuId/products',
            name: 'productListing',
            component: ProductListing
        },
        {
            path: '/menus/:menuId/products/:id',
            name: 'productForm',
            component: ProductForm
        },
        {
            path: '/menus/:menuId/product-categories/:id',
            name: 'productCategoryForm',
            component: ProductCategoryForm
        },
        {
            path: '/staff-members',
            name: 'staffMemberListing',
            component: StaffMemberListing
        },
        {
            path: '/staff-members/:id',
            name: 'staffMemberForm',
            component: StaffMemberForm
        },
        {
            path: '/roles/:id',
            name: 'roleForm',
            component: RoleForm
        },
        {
            path: '/roles',
            name: 'roleListing',
            component: RoleListing
        },
        {
            path: '/stores/:id',
            name: 'storeForm',
            component: StoreForm
        },
        {
            path: '/stores',
            name: 'storeListing',
            component: StoreListing
        },
        {
            path: '/general-settings',
            name: 'generalSettingsForm',
            component: GeneralSettingsForm
        },
        {
            path: '/printer-settings',
            name: 'printerSettingsForm',
            component: PrinterSettingsForm
        },
        {
            path: '/reports/product-sales',
            name: 'productSalesReport',
            component: ProductSalesReport
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        },
        {
            path: '/auth/login',
            name: 'login',
            component: AuthLogin
        },
        {
            path: '/auth/logout',
            name: 'logout',
            component: AuthLogout
        },
        {
            path: '/auth/forgot-password',
            name: 'forgotPassword',
            component: ForgotPassword
        },
        {
            path: '/404',
            name: 'notFound',
            component: NotFound
        },
        {
            path: '*',
            redirect: '/404'
        },
    ]
});

router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/auth/login', '/auth/logout', '/auth/forgot-password'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('auth_token');

    if (authRequired && !loggedIn) {
        return next('/auth/login');
    }

    let languageCode = "pt-BR";
    const storedLanguageCode = localStorage.getItem('language_code');
    if (storedLanguageCode) {
        languageCode = storedLanguageCode
    }
    i18n.i18next.changeLanguage(languageCode);
    moment.locale(languageCode)

    next();
});

export default router
